module.exports = __webpack_public_path__ + "img/logo-sas-branca.ebcab98a.svg";